import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function KullanimKosullariPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              Kullanım Koşulları
            </h1>

            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">1. Genel Hükümler</h2>
                <div className="space-y-3">
                  <p>
                    Bu kullanım koşulları, www.eminkuyumculuk.com.tr web sitesinin kullanımı ile 
                    ilgili şartları düzenlemektedir. Site sahibi:
                  </p>
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <p><strong>Emin Kuyumculuk</strong></p>
                    <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                    <p><strong>Telefon:</strong> 0531 603 68 91</p>
                    <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">2. Kabul ve Onay</h2>
                <p>
                  Bu web sitesini kullanarak, bu kullanım koşullarını tamamen okuduğunuzu, 
                  anladığınızı ve kabul ettiğinizi beyan etmiş olursunuz. Bu koşulları 
                  kabul etmiyorsanız, lütfen siteyi kullanmayın.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">3. Hizmetler</h2>
                <div className="space-y-3">
                  <p>Sitemiz aracılığıyla sunulan hizmetler:</p>
                  <ul className="list-disc list-inside ml-4 space-y-2">
                    <li>Altın ve kuyumculuk ürünlerinin online satışı</li>
                    <li>Ürün katalogu ve fiyat bilgileri</li>
                    <li>Müşteri hizmetleri ve destek</li>
                    <li>Güncel altın fiyatları bilgilendirmesi</li>
                    <li>Sipariş takip sistemi</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">4. Kullanıcı Yükümlülükleri</h2>
                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                  <p className="font-medium text-amber-800 mb-2">Kullanıcı olarak taahhüt edersiniz:</p>
                  <ul className="list-disc list-inside ml-4 space-y-1 text-sm text-amber-700">
                    <li>Doğru ve güncel bilgiler sağlamak</li>
                    <li>Sitede yasadışı faaliyetlerde bulunmamak</li>
                    <li>Başkalarının haklarına saygı göstermek</li>
                    <li>Site güvenliğini tehlikeye atmamak</li>
                    <li>Telif hakları ve fikri mülkiyet haklarını ihlal etmemek</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">5. Yasak Kullanımlar</h2>
                <div className="space-y-3">
                  <p>Aşağıdaki faaliyetler kesinlikle yasaktır:</p>
                  <ul className="list-disc list-inside ml-4 space-y-2">
                    <li>Sahte veya yanıltıcı bilgiler vermek</li>
                    <li>Spam veya istenmeyen e-posta göndermek</li>
                    <li>Siteye virüs veya zararlı kod yüklemek</li>
                    <li>Diğer kullanıcıları rahatsız edici davranışlarda bulunmak</li>
                    <li>Site içeriğini izinsiz kopyalamak veya dağıtmak</li>
                    <li>Otomatik sistemler kullanarak site verilerini toplamak</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">6. Fikri Mülkiyet Hakları</h2>
                <p>
                  Bu sitedeki tüm içerik (metin, görsel, logo, tasarım, yazılım) Emin Kuyumculuk'a 
                  aittir veya lisanslıdır. İzin alınmadan kullanılması yasaktır.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">7. Gizlilik</h2>
                <p>
                  Kişisel bilgilerinizin işlenmesi KVKK Aydınlatma Metnimizde detaylandırılmıştır. 
                  Bilgilerinizin güvenliğini sağlamak için gerekli tüm tedbirleri alıyoruz.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">8. Sorumluluk Sınırlaması</h2>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm">
                    <strong>Emin Kuyumculuk aşağıdaki durumlardan sorumlu değildir:</strong>
                  </p>
                  <ul className="list-disc list-inside ml-4 mt-2 space-y-1 text-sm">
                    <li>Site kullanımından doğabilecek doğrudan veya dolaylı zararlar</li>
                    <li>Üçüncü taraf sitelere yönlendirmelerden kaynaklanan sorunlar</li>
                    <li>Teknik arızalar veya kesintilerden kaynaklanan kayıplar</li>
                    <li>Kullanıcıların yanlış bilgi vermesinden doğan sorunlar</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">9. Fiyat ve Ürün Bilgileri</h2>
                <div className="space-y-3">
                  <p>
                    <strong>Fiyatlar:</strong> Sitedeki fiyatlar anlık olup, altın piyasasındaki 
                    dalgalanmalara bağlı olarak değişebilir.
                  </p>
                  <p>
                    <strong>Stok Durumu:</strong> Ürün stoklarımız sürekli güncellenmekle birlikte, 
                    stok tükenmesi durumunda size bilgi verilir.
                  </p>
                  <p>
                    <strong>Ürün Görselleri:</strong> Ürün görselleri gerçek ürünü yansıtacak 
                    şekilde seçilmiştir, ancak renk tonları farklılık gösterebilir.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">10. Değişiklikler</h2>
                <p>
                  Emin Kuyumculuk, bu kullanım koşullarını önceden haber vermeksizin değiştirme 
                  hakkını saklı tutar. Güncel koşullar her zaman bu sayfada yayınlanır.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">11. Hesap İptali</h2>
                <p>
                  Bu koşulları ihlal eden kullanıcıların hesapları önceden haber verilmeksizin 
                  kapatılabilir. İptal durumunda bekleyen siparişler ve ödemeler uygun şekilde 
                  sonuçlandırılır.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">12. Uyuşmazlık Çözümü</h2>
                <div className="space-y-3">
                  <p>
                    Bu kullanım koşullarından doğacak uyuşmazlıklarda Türkiye Cumhuriyeti kanunları 
                    uygulanır.
                  </p>
                  <p>
                    <strong>Yetkili Mahkeme:</strong> Ankara Mahkemeleri ve İcra Müdürlükleri yetkilidir.
                  </p>
                  <p>
                    <strong>Tüketici Hakları:</strong> Tüketici sıfatındaki kullanıcılar için 
                    Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">13. İletişim</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p className="text-gray-600 mb-4">
                    Kullanım koşulları hakkında sorularınız için:
                  </p>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Emin Kuyumculuk</strong></p>
                    <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                    <p><strong>Telefon:</strong> 0531 603 68 91</p>
                    <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                    <p><strong>Çalışma Saatleri:</strong> Pazartesi - Cumartesi 09:00 - 19:00</p>
                  </div>
                </div>
              </section>

              <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                <p className="text-sm text-amber-800">
                  <strong>Yürürlük Tarihi:</strong> {new Date().toLocaleDateString('tr-TR')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}